import landGroen from "./img/icons/land_groen.svg";
import landBlauw from "./img/icons/land_blauw.svg";
import landGeel from "./img/icons/land_geel.svg";
import landOranje from "./img/icons/land_oranje.svg";
import landPaars from "./img/icons/land_paars.svg";
import landRood from "./img/icons/land_rood.svg";
import camera from "./img/icons/camera.svg";
import checklist from "./img/icons/checklist.svg";
import bonus from "./img/icons/bonus.svg";
import movie from "./img/icons/movie.svg";
import team from "./img/icons/economy/team.svg";
import medal from "./img/medal.svg";
import lock from "./img/icons/lock.svg";
import greyLock from "./img/icons/Lock_grey.svg";
import pen from "./img/icons/pen.svg";
import locked from "./img/icons/locked.svg";
import add from "./img/icons/add.svg";
import play2 from "./img/icons/play2.svg";
import startup from "./img/icons/opstart.svg";
import pdf from "./img/icons/pdf.svg";
import trash from './img/icons/delete.svg';
import globas from './img/icons/globas.svg';
import beleidskeuze from './img/icons/beleidskeuze.svg';
import gift from './img/icons/belasting-6.svg';
import minGlobas from './img/icons/economy/min-globas.svg';
import upGlobas from './img/icons/economy/up-globas.svg';
import thumbsUp from './img/thumbs_up.svg';
import thumbsDown from './img/thumbs_down.svg';
import megafoon from './img/megafoon.svg';
import check from './img/icons/check.svg';
import pauze from './img/icons/pauze.svg';
import download from './img/icons/download.svg';
import fairaway from './img/fairaway_logo.png';
import link from './img/icons/link.svg';

import print from './img/icons/popup/print.png';

import AB from './img/icons/belasting-1.svg';
import BB from './img/icons/belasting-2.svg';
import CB from './img/icons/belasting-3.svg';
import VVB from './img/icons/belasting-4.svg';
import VB from './img/icons/belasting-5.svg';
import LB from './img/icons/L-belasting-1.svg';

import ministryWI from "./img/icons/ministries/WI.svg";
import ministryGZ from "./img/icons/ministries/GZ.svg";
import ministryOW from "./img/icons/ministries/OW.svg";
import ministryOT from "./img/icons/ministries/OT.svg";
import ministryVR from "./img/icons/ministries/VR.svg";
import ministryIE from "./img/icons/ministries/IE.svg";
import ministryFB from "./img/icons/ministries/FB.svg";
import ministryLV from "./img/icons/ministries/LV.svg";
import ministryKN from "./img/icons/ministries/KN.svg";
import ministryOH from "./img/icons/ministries/OH.svg";
import ministryWS from "./img/icons/ministries/WS.svg";
import ministryHB from "./img/icons/ministries/HB.svg";
import ministryEH from "./img/icons/ministries/EH.svg";
import ministryMC from "./img/icons/ministries/MC.svg";

import ministryWI_Edge from "./img/icons/ministries_edge/WI.png";
import ministryGZ_Edge from "./img/icons/ministries_edge/GZ.png";
import ministryOW_Edge from "./img/icons/ministries_edge/OW.png";
import ministryOT_Edge from "./img/icons/ministries_edge/OT.png";
import ministryVR_Edge from "./img/icons/ministries_edge/VR.png";
import ministryIE_Edge from "./img/icons/ministries_edge/IE.png";
import ministryFB_Edge from "./img/icons/ministries_edge/FB.png";
import ministryLV_Edge from "./img/icons/ministries_edge/LV.png";
import ministryKN_Edge from "./img/icons/ministries_edge/KN.png";
import ministryOH_Edge from "./img/icons/ministries_edge/OH.png";
import ministryWS_Edge from "./img/icons/ministries_edge/WS.png";
import ministryHB_Edge from "./img/icons/ministries_edge/HB.png";
import ministryEH_Edge from "./img/icons/ministries_edge/EH.png";
import ministryMC_Edge from "./img/icons/ministries_edge/MC.png";

import map_Beleidskeuzes from "./img/MapElements/Beleidskeuzes.png";
import map_Economy from "./img/MapElements/Economy.png";
import map_FB__FB1 from "./img/MapElements/FB/FB1.png";
import map_FB__FB12x from "./img/MapElements/FB/FB1@2x.png";
import map_FB__FB2 from "./img/MapElements/FB/FB2.png";
import map_FB__FB22x from "./img/MapElements/FB/FB2@2x.png";
import map_FB__FB3 from "./img/MapElements/FB/FB3.png";
import map_FB__FB32x from "./img/MapElements/FB/FB3@2x.png";
import map_FB__FB4 from "./img/MapElements/FB/FB4.png";
import map_FB__FB42x from "./img/MapElements/FB/FB4@2x.png";
import map_FB__FB5 from "./img/MapElements/FB/FB5.png";
import map_FB__FB52x from "./img/MapElements/FB/FB5@2x.png";
import map_GZ__GZ1 from "./img/MapElements/GZ/GZ1.png";
import map_GZ__GZ12x from "./img/MapElements/GZ/GZ1@2x.png";
import map_GZ__GZ2 from "./img/MapElements/GZ/GZ2.png";
import map_GZ__GZ22x from "./img/MapElements/GZ/GZ2@2x.png";
import map_GZ__GZ3 from "./img/MapElements/GZ/GZ3.png";
import map_GZ__GZ32x from "./img/MapElements/GZ/GZ3@2x.png";
import map_GZ__GZ4 from "./img/MapElements/GZ/GZ4.png";
import map_GZ__GZ42x from "./img/MapElements/GZ/GZ4@2x.png";
import map_GZ__GZ5 from "./img/MapElements/GZ/GZ5.png";
import map_GZ__GZ52x from "./img/MapElements/GZ/GZ5@2x.png";
import map_HB__HB1 from "./img/MapElements/HB/HB1.png";
import map_HB__HB12x from "./img/MapElements/HB/HB1@2x.png";
import map_HB__HB2 from "./img/MapElements/HB/HB2.png";
import map_HB__HB22x from "./img/MapElements/HB/HB2@2x.png";
import map_HB__HB3 from "./img/MapElements/HB/HB3.png";
import map_HB__HB32x from "./img/MapElements/HB/HB3@2x.png";
import map_HB__HB4 from "./img/MapElements/HB/HB4.png";
import map_HB__HB42x from "./img/MapElements/HB/HB4@2x.png";
import map_IE__IE1 from "./img/MapElements/IE/IE1.png";
import map_IE__IE12x from "./img/MapElements/IE/IE1@2x.png";
import map_IE__IE2 from "./img/MapElements/IE/IE2.png";
import map_IE__IE22x from "./img/MapElements/IE/IE2@2x.png";
import map_IE__IE3 from "./img/MapElements/IE/IE3.png";
import map_IE__IE32x from "./img/MapElements/IE/IE3@2x.png";
import map_IE__IE4 from "./img/MapElements/IE/IE4.png";
import map_IE__IE42x from "./img/MapElements/IE/IE4@2x.png";
import map_IE__IE5 from "./img/MapElements/IE/IE5.png";
import map_IE__IE52x from "./img/MapElements/IE/IE5@2x.png";
import map_KN__KN1 from "./img/MapElements/KN/KN1.png";
import map_KN__KN12x from "./img/MapElements/KN/KN1@2x.png";
import map_KN__KN2 from "./img/MapElements/KN/KN2.png";
import map_KN__KN22x from "./img/MapElements/KN/KN2@2x.png";
import map_KN__KN3 from "./img/MapElements/KN/KN3.png";
import map_KN__KN32x from "./img/MapElements/KN/KN3@2x.png";
import map_KN__KN4 from "./img/MapElements/KN/KN4.png";
import map_KN__KN42x from "./img/MapElements/KN/KN4@2x.png";
import map_LV__LV1 from "./img/MapElements/LV/LV1.png";
import map_LV__LV12x from "./img/MapElements/LV/LV1@2x.png";
import map_LV__LV13x from "./img/MapElements/LV/LV1@3x.png";
import map_LV__LV14x from "./img/MapElements/LV/LV1@4x.png";
import map_LV__LV2 from "./img/MapElements/LV/LV2.png";
import map_LV__LV22x from "./img/MapElements/LV/LV2@2x.png";
import map_LV__LV23x from "./img/MapElements/LV/LV2@3x.png";
import map_LV__LV24x from "./img/MapElements/LV/LV2@4x.png";
import map_LV__LV3 from "./img/MapElements/LV/LV3.png";
import map_LV__LV32x from "./img/MapElements/LV/LV3@2x.png";
import map_LV__LV33x from "./img/MapElements/LV/LV3@3x.png";
import map_LV__LV34x from "./img/MapElements/LV/LV3@4x.png";
import map_LV__LV4 from "./img/MapElements/LV/LV4.png";
import map_LV__LV42x from "./img/MapElements/LV/LV4@2x.png";
import map_LV__LV43x from "./img/MapElements/LV/LV4@3x.png";
import map_LV__LV44x from "./img/MapElements/LV/LV4@4x.png";
import map_LV__LV5 from "./img/MapElements/LV/LV5.png";
import map_LV__LV52x from "./img/MapElements/LV/LV5@2x.png";
import map_LV__LV53x from "./img/MapElements/LV/LV5@3x.png";
import map_LV__LV54x from "./img/MapElements/LV/LV5@4x.png";
import map_MC__MC1 from "./img/MapElements/MC/MC1.png";
import map_MC__MC12x from "./img/MapElements/MC/MC1@2x.png";
import map_MC__MC2 from "./img/MapElements/MC/MC2.png";
import map_MC__MC22x from "./img/MapElements/MC/MC2@2x.png";
import map_MC__MC3 from "./img/MapElements/MC/MC3.png";
import map_MC__MC32x from "./img/MapElements/MC/MC3@2x.png";
import map_MC__MC4 from "./img/MapElements/MC/MC4.png";
import map_MC__MC42x from "./img/MapElements/MC/MC4@2x.png";
import map_MC__MC5 from "./img/MapElements/MC/MC5.png";
import map_MC__MC52x from "./img/MapElements/MC/MC5@2x.png";
import map_OH__OH1 from "./img/MapElements/OH/OH1.png";
import map_OH__OH12x from "./img/MapElements/OH/OH1@2x.png";
import map_OH__OH2 from "./img/MapElements/OH/OH2.png";
import map_OH__OH22x from "./img/MapElements/OH/OH2@2x.png";
import map_OH__OH3 from "./img/MapElements/OH/OH3.png";
import map_OH__OH32x from "./img/MapElements/OH/OH3@2x.png";
import map_OH__OH4 from "./img/MapElements/OH/OH4.png";
import map_OH__OH42x from "./img/MapElements/OH/OH4@2x.png";
import map_OT__OT1 from "./img/MapElements/OT/OT1.png";
import map_OT__OT12x from "./img/MapElements/OT/OT1@2x.png";
import map_OT__OT2 from "./img/MapElements/OT/OT2.png";
import map_OT__OT22x from "./img/MapElements/OT/OT2@2x.png";
import map_OT__OT3 from "./img/MapElements/OT/OT3.png";
import map_OT__OT32x from "./img/MapElements/OT/OT3@2x.png";
import map_OT__OT4 from "./img/MapElements/OT/OT4.png";
import map_OT__OT42x from "./img/MapElements/OT/OT4@2x.png";
import map_OW__OW1 from "./img/MapElements/OW/OW1.png";
import map_OW__OW12x from "./img/MapElements/OW/OW1@2x.png";
import map_OW__OW2 from "./img/MapElements/OW/OW2.png";
import map_OW__OW22x from "./img/MapElements/OW/OW2@2x.png";
import map_OW__OW3 from "./img/MapElements/OW/OW3.png";
import map_OW__OW32x from "./img/MapElements/OW/OW3@2x.png";
import map_OW__OW4 from "./img/MapElements/OW/OW4.png";
import map_OW__OW42x from "./img/MapElements/OW/OW4@2x.png";
import map_OW__OW5 from "./img/MapElements/OW/OW5.png";
import map_OW__OW52x from "./img/MapElements/OW/OW5@2x.png";
import map_VR__VR1 from "./img/MapElements/VR/VR1.png";
import map_VR__VR12x from "./img/MapElements/VR/VR1@2x.png";
import map_VR__VR2 from "./img/MapElements/VR/VR2.png";
import map_VR__VR22x from "./img/MapElements/VR/VR2@2x.png";
import map_VR__VR3 from "./img/MapElements/VR/VR3.png";
import map_VR__VR32x from "./img/MapElements/VR/VR3@2x.png";
import map_VR__VR4 from "./img/MapElements/VR/VR4.png";
import map_VR__VR42x from "./img/MapElements/VR/VR4@2x.png";
import map_VR__VR5 from "./img/MapElements/VR/VR5.png";
import map_VR__VR52x from "./img/MapElements/VR/VR5@2x.png";
import map_WI__WI1 from "./img/MapElements/WI/WI1.png";
import map_WI__WI12x from "./img/MapElements/WI/WI1@2x.png";
import map_WI__WI2 from "./img/MapElements/WI/WI2.png";
import map_WI__WI22x from "./img/MapElements/WI/WI2@2x.png";
import map_WI__WI3 from "./img/MapElements/WI/WI3.png";
import map_WI__WI32x from "./img/MapElements/WI/WI3@2x.png";
import map_WI__WI4 from "./img/MapElements/WI/WI4.png";
import map_WI__WI42x from "./img/MapElements/WI/WI4@2x.png";
import map_WI__WI5 from "./img/MapElements/WI/WI5.png";
import map_WI__WI52x from "./img/MapElements/WI/WI5@2x.png";
import map_WS__WS1 from "./img/MapElements/WS/WS1.png";
import map_WS__WS12x from "./img/MapElements/WS/WS1@2x.png";
import map_WS__WS2 from "./img/MapElements/WS/WS2.png";
import map_WS__WS22x from "./img/MapElements/WS/WS2@2x.png";
import map_WS__WS3 from "./img/MapElements/WS/WS3.png";
import map_WS__WS32x from "./img/MapElements/WS/WS3@2x.png";
import map_WS__WS4 from "./img/MapElements/WS/WS4.png";
import map_WS__WS42x from "./img/MapElements/WS/WS4@2x.png";
import map_WS__WS5 from "./img/MapElements/WS/WS5.png";
import map_WS__WS52x from "./img/MapElements/WS/WS5@2x.png";
import map_highlight from "./img/MapElements/highlight.png";
import map_shadow from "./img/MapElements/shadow.png";

//Kopie van handel en bedrijven voor eerlijke handel
import map_EH__EH1 from "./img/MapElements/HB/HB1.png";
import map_EH__EH12x from "./img/MapElements/HB/HB1@2x.png";
import map_EH__EH2 from "./img/MapElements/HB/HB2.png";
import map_EH__EH22x from "./img/MapElements/HB/HB2@2x.png";
import map_EH__EH3 from "./img/MapElements/HB/HB3.png";
import map_EH__EH32x from "./img/MapElements/HB/HB3@2x.png";
import map_EH__EH4 from "./img/MapElements/HB/HB4.png";
import map_EH__EH42x from "./img/MapElements/HB/HB4@2x.png";

import cursorImg from "./img/cursor.png";

import pc1_1 from './img/icons/beleidskeuzes_basic/1.1.png';
import pc1_2 from './img/icons/beleidskeuzes_basic/1.2.png';
import pc1_3 from './img/icons/beleidskeuzes_basic/1.3.png';
import pc1_4 from './img/icons/beleidskeuzes_basic/1.4.png';
import pc1_5 from './img/icons/beleidskeuzes_basic/1.5.png';
import pc1_6 from './img/icons/beleidskeuzes_basic/1.6.png';
import pc2_1 from './img/icons/beleidskeuzes_basic/2.1.png';
import pc2_2 from './img/icons/beleidskeuzes_basic/2.2.png';
import pc2_3 from './img/icons/beleidskeuzes_basic/2.3.png';
import pc2_4 from './img/icons/beleidskeuzes_basic/2.4.png';
import pc2_5 from './img/icons/beleidskeuzes_basic/2.5.png';
import pc2_6 from './img/icons/beleidskeuzes_basic/2.6.png';
import pc3_1 from './img/icons/beleidskeuzes_basic/3.1.png';
import pc3_2 from './img/icons/beleidskeuzes_basic/3.2.png';
import pc3_3 from './img/icons/beleidskeuzes_basic/3.3.png';
import pc3_4 from './img/icons/beleidskeuzes_basic/3.4.png';
import pc3_5 from './img/icons/beleidskeuzes_basic/3.5.png';
import pc3_6 from './img/icons/beleidskeuzes_basic/3.6.png';
import pc4_1 from './img/icons/beleidskeuzes_basic/4.1.png';
import pc4_2 from './img/icons/beleidskeuzes_basic/4.2.png';
import pc4_3 from './img/icons/beleidskeuzes_basic/4.3.png';
import pc4_4 from './img/icons/beleidskeuzes_basic/4.4.png';
import pc4_5 from './img/icons/beleidskeuzes_basic/4.5.png';
import pc4_6 from './img/icons/beleidskeuzes_basic/4.6.png';

import groepsbewerk from './img/icons/groepsbewerk.svg';
import testen from './img/icons/testen.svg';

import pro_red from './img/MapElements/Plateau_H_1.svg';
import pro_yellow from './img/MapElements/Plateau_H_2.svg';
import pro_green from './img/MapElements/Plateau_H_3.svg';

import basic_red from './img/MapElements/Plateau_L_1.svg';
import basic_lowOrange from './img/MapElements/Plateau_L_2.svg';
import basic_lowYellow from './img/MapElements/Plateau_L_3.svg';
import basic_green from './img/MapElements/Plateau_L_4.svg';

export const cursor = cursorImg;

export const beleidskeuzes = {
  'NLLB1-1': pc1_1,
  'NLLB1-2': pc1_2,
  'NLLB1-3': pc1_3,
  'NLLB1-4': pc1_4,
  'NLLB1-5': pc1_5,
  'NLLB1-6': pc1_6,
  'NLLB2-1': pc2_1,
  'NLLB2-2': pc2_2,
  'NLLB2-3': pc2_3,
  'NLLB2-4': pc2_4,
  'NLLB2-5': pc2_5,
  'NLLB2-6': pc2_6,
  'NLLB3-1': pc3_1,
  'NLLB3-2': pc3_2,
  'NLLB3-3': pc3_3,
  'NLLB3-4': pc3_4,
  'NLLB3-5': pc3_5,
  'NLLB3-6': pc3_6,
  'NLLB4-1': pc4_1,
  'NLLB4-2': pc4_2,
  'NLLB4-3': pc4_3,
  'NLLB4-4': pc4_4,
  'NLLB4-5': pc4_5,
  'NLLB4-6': pc4_6,
};

export const icons = {
  print,
  fairaway,
  globas,
  checklist,
  bonus,
  movie,
  camera,
  team,
  medal,
  pen,
  lock,
  locked,
  download,
  add,
  play2,
  startup,
  pdf,
  trash,
  beleidskeuze,
  minGlobas,
  upGlobas,
  gift,
  thumbsDown,
  thumbsUp,
  megafoon,
  check,
  groepsbewerk,
  testen,
  pauze,
  link,
  greyLock,
};

export const belastingIcons = {
  AB,
  CB,
  BB,
  VVB,
  VB,
  LB
};

export const groupIcons = {
  groen: landGroen,
  blauw: landBlauw,
  geel: landGeel,
  oranje: landOranje,
  paars: landPaars,
  rood: landRood
};

export const mapColors = {
  pro_red,
  pro_yellow,
  pro_green,
  basic_red,
  basic_lowOrange,
  basic_lowYellow,
  basic_green
};

export const mapElements = {
  map_Beleidskeuzes,
  map_Economy,
  map_FB__FB1,
  map_FB__FB12x,
  map_FB__FB2,
  map_FB__FB22x,
  map_FB__FB3,
  map_FB__FB32x,
  map_FB__FB4,
  map_FB__FB42x,
  map_FB__FB5,
  map_FB__FB52x,
  map_GZ__GZ1,
  map_GZ__GZ12x,
  map_GZ__GZ2,
  map_GZ__GZ22x,
  map_GZ__GZ3,
  map_GZ__GZ32x,
  map_GZ__GZ4,
  map_GZ__GZ42x,
  map_GZ__GZ5,
  map_GZ__GZ52x,
  map_HB__HB1,
  map_HB__HB12x,
  map_HB__HB2,
  map_HB__HB22x,
  map_HB__HB3,
  map_HB__HB32x,
  map_HB__HB4,
  map_HB__HB42x,
  map_IE__IE1,
  map_IE__IE12x,
  map_IE__IE2,
  map_IE__IE22x,
  map_IE__IE3,
  map_IE__IE32x,
  map_IE__IE4,
  map_IE__IE42x,
  map_IE__IE5,
  map_IE__IE52x,
  map_KN__KN1,
  map_KN__KN12x,
  map_KN__KN2,
  map_KN__KN22x,
  map_KN__KN3,
  map_KN__KN32x,
  map_KN__KN4,
  map_KN__KN42x,
  map_LV__LV1,
  map_LV__LV12x,
  map_LV__LV13x,
  map_LV__LV14x,
  map_LV__LV2,
  map_LV__LV22x,
  map_LV__LV23x,
  map_LV__LV24x,
  map_LV__LV3,
  map_LV__LV32x,
  map_LV__LV33x,
  map_LV__LV34x,
  map_LV__LV4,
  map_LV__LV42x,
  map_LV__LV43x,
  map_LV__LV44x,
  map_LV__LV5,
  map_LV__LV52x,
  map_LV__LV53x,
  map_LV__LV54x,
  map_MC__MC1,
  map_MC__MC12x,
  map_MC__MC2,
  map_MC__MC22x,
  map_MC__MC3,
  map_MC__MC32x,
  map_MC__MC4,
  map_MC__MC42x,
  map_MC__MC5,
  map_MC__MC52x,
  map_OH__OH1,
  map_OH__OH12x,
  map_OH__OH2,
  map_OH__OH22x,
  map_OH__OH3,
  map_OH__OH32x,
  map_OH__OH4,
  map_OH__OH42x,
  map_OT__OT1,
  map_OT__OT12x,
  map_OT__OT2,
  map_OT__OT22x,
  map_OT__OT3,
  map_OT__OT32x,
  map_OT__OT4,
  map_OT__OT42x,
  map_OW__OW1,
  map_OW__OW12x,
  map_OW__OW2,
  map_OW__OW22x,
  map_OW__OW3,
  map_OW__OW32x,
  map_OW__OW4,
  map_OW__OW42x,
  map_OW__OW5,
  map_OW__OW52x,
  map_VR__VR1,
  map_VR__VR12x,
  map_VR__VR2,
  map_VR__VR22x,
  map_VR__VR3,
  map_VR__VR32x,
  map_VR__VR4,
  map_VR__VR42x,
  map_VR__VR5,
  map_VR__VR52x,
  map_WI__WI1,
  map_WI__WI12x,
  map_WI__WI2,
  map_WI__WI22x,
  map_WI__WI3,
  map_WI__WI32x,
  map_WI__WI4,
  map_WI__WI42x,
  map_WI__WI5,
  map_WI__WI52x,
  map_WS__WS1,
  map_WS__WS12x,
  map_WS__WS2,
  map_WS__WS22x,
  map_WS__WS3,
  map_WS__WS32x,
  map_WS__WS4,
  map_WS__WS42x,
  map_WS__WS5,
  map_WS__WS52x,
  map_highlight,
  map_shadow,
  map_EH__EH1,
  map_EH__EH12x,
  map_EH__EH2,
  map_EH__EH22x,
  map_EH__EH3,
  map_EH__EH32x,
  map_EH__EH4,
  map_EH__EH42x
};

let prepMinistryIcons = {
  WI: ministryWI,
  GZ: ministryGZ,
  OW: ministryOW,
  OT: ministryOT,
  VR: ministryVR,
  IE: ministryIE,
  FB: ministryFB,
  LV: ministryLV,
  KN: ministryKN,
  OH: ministryOH,
  WS: ministryWS,
  HB: ministryHB,
  MC: ministryMC,
  EH: ministryEH,
};

if(window.navigator.userAgent.indexOf("Edge") > -1) {
  prepMinistryIcons = {
    WI: ministryWI_Edge,
    GZ: ministryGZ_Edge,
    OW: ministryOW_Edge,
    OT: ministryOT_Edge,
    VR: ministryVR_Edge,
    IE: ministryIE_Edge,
    FB: ministryFB_Edge,
    LV: ministryLV_Edge,
    KN: ministryKN_Edge,
    OH: ministryOH_Edge,
    WS: ministryWS_Edge,
    HB: ministryHB_Edge,
    MC: ministryMC_Edge,
    EH: ministryEH_Edge,
  };
}

export const ministryIcons = prepMinistryIcons;




// WEBPACK FOOTER //
// ./src/assets/assets.js